// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sem-historico {\n  font-weight: bold;\n  font-size: 16px;\n  text-align: center;\n  margin: 16px;\n}\n\n.historico-button {\n  width: 100%;\n  border: 0;\n  font-weight: bold;\n  font-size: 16px;\n  text-align: center;\n  padding: 8px;\n  margin: 8px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
